import { Pagination as AntdPagination, PaginationProps, Typography, Select } from 'antd'
import { DropdownPageLimit } from 'constants/dropdown'
import { IconChevronDown } from 'components/icons'

interface PropsPagination {
  disabled?: boolean
  limit: number
  currentPage: number
  totalRows: number
  setLimit(value: number): void
  onPageChanged(page: number, pageSize: number): void
  showLimitPage?: boolean
}

const prevPagination = (prev: PaginationProps) => (
  <IconChevronDown
    color={prev?.disabled ? '#CDD5DF' : '#121926'}
    className={
      prev?.disabled
        ? 'pagination__icon-prev pagination__icon-prev--disabled'
        : 'pagination__icon-prev'
    }
  />
)

const nextPagination = (next: PaginationProps) => (
  <IconChevronDown
    color={next?.disabled ? '#CDD5DF' : '#121926'}
    className={
      next?.disabled
        ? 'pagination__icon-next pagination__icon-next--disabled'
        : 'pagination__icon-next'
    }
  />
)
function Pagination(props: PropsPagination) {
  return (
    <div data-testid="pagination" className="pagination">
      {/* Pagination limiter */}
      {props.showLimitPage && (
        <div>
          <Typography.Text className="pagination__total">Tampilkan per halaman</Typography.Text>
          <Select
            data-testid="select-limit"
            disabled={props.disabled}
            onChange={(e) => props.setLimit(e)}
            defaultValue={props.limit}
            className="dropdown-member"
            suffixIcon={<IconChevronDown />}
          >
            {DropdownPageLimit.map((list) => {
              return (
                <Select.Option
                  data-testid={'select-limit-item-' + list.value}
                  key={list.key}
                  value={list.value}
                >
                  {list.value}
                </Select.Option>
              )
            })}
          </Select>
        </div>
      )}

      {/* Pagination link */}
      <div className="ml-auto">
        <AntdPagination
          data-testid="pagination-control"
          disabled={props.disabled}
          onChange={props.onPageChanged}
          showSizeChanger={false}
          prevIcon={prevPagination}
          nextIcon={nextPagination}
          current={props.currentPage}
          total={props.totalRows}
          pageSize={props.limit}
        />
      </div>
    </div>
  )
}

export default Pagination
